module.exports = __webpack_public_path__ + "static/media/img-06.39cdc611.png";